import '../css/pages/pportfolio.css'
import { useEffect, useState } from "react"
import axios from 'axios'
import Transitions from '../component/Transitions';

const Portfolio = () => {
  const [portfolios, setPortfolios] = useState([]);
  const [loader,setLoader] = useState({opacity:0})

  setTimeout(() => {
    document.getElementById('trigger').checked = true
  }, 1);

  //every first time load page, run func get data
  useEffect(() => {
    getPortfolios()
  },[])

  //Get data from portfolio collection
  const getPortfolios = async () => {
    setLoader({opacity:1,transition: "all 1s linear"})
    try {
      const response = await axios.get('https://luthfinr-portfolios.herokuapp.com/portfolio')
      setLoader({display:'none'})
      setPortfolios(response.data);  
    } catch(error) {
      console.log(error.message)
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    }
    // luthfinr-portfolios.herokuapp.com
   
  }

  //Delay appearence of scrolldown navigation
  // const scrollDown = () => {
  //   setTimeout(() => {
  //     setStyleScroll({opacity:1,transition: "all 0.3s linear"})
  //   }, 5000);
  // }

  // Diminished the scrolldown navigation after scroll page
  // const scrollDismiss = () => {
  //   setStyleScroll({opacity:0})
  // }

  return (
    <section className='portfolio'> {/*onScroll={scrollDismiss} onLoad={scrollDown}*/}
      <section className="loader" style={loader}>
        <div></div>
      </section>
      <Transitions>
        {/* mapping data from database */}
        { 
          portfolios.map((portfolio,i) => {
            return (
              <div key={portfolio._id} className="portfolio-content">
                <div  className="img" style={{backgroundImage: `url(${portfolio.image})`}}>
                  <div className='backdrop'>
                    <h1 className="title">{portfolio.projectName}</h1>
                    <h3 className="type">{portfolio.projectType}</h3>
                    <h3 className='tech'>{portfolio.tech.join('/')}</h3>
                    <a href={`${portfolio.link}`} target={"_blank"} rel="noreferrer"><button className='link'>Visit page</button></a>
                  </div>
                </div>
              </div>
            )
          })


          // portfolios.map((portfolio,i) => {
          //   console.log(i)
          //   return (
          //     <div key={portfolio._id} className="portfolio-content" >
          //       <div className="img" style={{backgroundImage: `url(${portfolio.image})`}}></div>
          //       <div className="img" style={{backgroundImage: `url(${portfolio.image})`}}></div>
          //       <div className="img" style={{backgroundImage: `url(${portfolio.image})`}}></div>
          //       <div className="img" style={{backgroundImage: `url(${portfolio.image})`}}></div>
          //       {/* <h1 className="project-name">{portfolio.projectName}</h1>
          //       <h3 className="project-type">{portfolio.projectType}</h3>
          //       <p className="project-desc">{portfolio.desc}</p>
          //       <button className="project-link"><a href={`${portfolio.link}`} target={"_blank"} rel="noreferrer">Visit page</a></button> */}
          //     </div>
          //   )
          // })
        }
        {/* <div className="scroll" style={styleScroll}>
          <h5 className="textScroll">Scroll Down</h5>
          <img src={vector} alt="" className="arrowScroll" />
        </div> */}
      </Transitions>
    </section>
  )
}

export default Portfolio